import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme from 'fe-appdir-lib-theme';
import { SvgIcon, Magnify, XLight } from 'fe-comp-svg-icon';

const PROP_TYPES = {
  isOpen: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

const SearchButton = styled.button`
  border: 0;
  background: transparent;
  z-index: 2001;
  cursor: pointer;
  ${(props) => (props.isOpen ? 'transform: translateX(46px)' : '')};

  &:focus {
    outline: none;
  }
`;

const MagnifyingGlass = ({ isOpen, onClick }) => (
  <SearchButton isOpen={isOpen} onClick={onClick}>
    <SvgIcon
      glyph={isOpen ? XLight : Magnify}
      size={16}
      fill={theme.colorGrey20}
    />
  </SearchButton>
);

MagnifyingGlass.propTypes = PROP_TYPES;

export default MagnifyingGlass;
